import { productsDataBreads } from './productsDataBreadsPrd';
import { productsDataSweets } from './productsDataSweetsPrd';

export const productsData = [...productsDataBreads, ...productsDataSweets];
